import React from 'react'

import './SocialNetworks.scss'

class SocialNetworks extends React.Component {

  render() {

    // Other container's classes available are:
    // social-networks--inline
    // social-networks--inline-medium
    // social-networks--inline-large
    // align-center (it's from foundation)

    let containerClass = 'social-networks text-center mb2'

    let customContainerClass = this.props.className

    if (customContainerClass) {
      containerClass = `${containerClass} ${customContainerClass}`
    }

    return (

      <div className={containerClass}>

        <h6 className='text'>Redes sociais</h6>

        <ul className='menu align-center'>

          {this.props.data.map((item, index) => (

            <li key={`social-networks-item-${index}`}>
              <a href={item.url} title={item.label} target='_blank' rel='noopener noreferrer'><i className={item.icon}></i></a>
            </li>

          ))}

        </ul>
      </div>

    )
  }
}

SocialNetworks.defaultProps = {
  data: [],
}


export default SocialNetworks



// WEBPACK FOOTER //
// ./src/components/shared/elements/SocialNetworks/SocialNetworks.js